import { useMemo } from 'react';

// third-party
import useSWR, { mutate } from 'swr';

// project-imports
import { fetcher } from 'utils/axios';

// types
import { MenuProps, NavItemType } from 'types/menu';
import { Book1 } from 'iconsax-reactjs';

const initialState: MenuProps = {
  isDashboardDrawerOpened: false,
  isComponentDrawerOpened: true
};

const staticMenuItem = {
  id: 'finance',
  title: 'finance',
  type: 'item',
  url: '/dashboard/finance',
  breadcrumbs: false
};

// ==============================|| API - MENU ||============================== //

const endpoints = {
  key: 'api/menu',
  master: 'master',
  dashboard: '/dashboard' // server URL
};

export function useGetMenu() {
  // const { data, isLoading, error, isValidating } = useSWR(endpoints.key + endpoints.dashboard, fetcher, {
  //   revalidateIfStale: false,
  //   revalidateOnFocus: false,
  //   revalidateOnReconnect: false
  // });

  const memoizedValue = useMemo(() => {
    //   let updatedMenu = data?.dashboard;

    //   if (updatedMenu && Array.isArray(updatedMenu.children) && updatedMenu.children.length > 0) {
    //     updatedMenu = {
    //       ...updatedMenu,
    //       children: updatedMenu.children.map((group: NavItemType) => {
    //         if (Array.isArray(group.children)) {
    //           return {
    //             ...group,
    //             children: [...group.children, staticMenuItem]
    //           };
    //         }
    //         return group;
    //       })
    //     };
    //   }

    return {
      menu: {
        id: 'dashboard',
        title: 'dashboard',
        type: 'collapse',
        icon: Book1,
        children: [
          {
            id: 'dashboard1',
            title: 'dashboard',
            type: 'item',
            url: '/dashboard',
            breadcrumbs: false
          }
        ]
      } as NavItemType,
      menuLoading: false,
      menuError: null,
      menuValidating: false,
      menuEmpty: true
    };
  }, []);

  return memoizedValue;
}

export function useGetMenuMaster() {
  const { data, isLoading } = useSWR(endpoints.key + endpoints.master, () => initialState, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  const memoizedValue = useMemo(
    () => ({
      menuMaster: data as MenuProps,
      menuMasterLoading: isLoading
    }),
    [data, isLoading]
  );

  return memoizedValue;
  // return {
  //   menuMaster: {
  //     isDashboardDrawerOpened: true,
  //     isComponentDrawerOpened: true
  //   } as MenuProps,
  //   menuMasterLoading: false
  // };
}

export function handlerComponentDrawer(isComponentDrawerOpened: boolean) {
  // to update local state based on key

  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster: any) => {
      return { ...currentMenuMaster, isComponentDrawerOpened };
    },
    false
  );
}

export function handlerDrawerOpen(isDashboardDrawerOpened: boolean) {
  // to update local state based on key

  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster: any) => {
      return { ...currentMenuMaster, isDashboardDrawerOpened };
    },
    false
  );
}
